import _defineProperty from "@babel/runtime/helpers/defineProperty";
var CSS_VAR_WIDTH = '--local-dynamic-table-width';
export var getTruncationStyleVars = function getTruncationStyleVars(_ref) {
  var width = _ref.width;
  return typeof width !== 'undefined' ? _defineProperty({}, CSS_VAR_WIDTH, "".concat(width, "%")) : undefined;
};